import { AxiosResponse } from "axios";
import { call, CallEffect, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { Action } from "redux-saga";
import { ReducersTypes } from "@/redux/reducers/Models";
import { automaticApi } from "@/settings/api";
import {
  clearString,
  getFormattedDeviceFingerPrintID,
} from "@/utils/functions";
import moment from "moment";

export interface Fetch {
  visitorId: string;
  vehicleInfos: {
    brandName?: string;
    modelName?: string;
  };
  vehicle: {
    type: {
      text: string;
      value: number;
    };
    plate: string;
    brand: string;
    model: string;
    year: string;
    axle: string;
    plateCode: string;
  };
  callback: (success: boolean) => void;
}

export interface CreateVehicleAction {
  type: string;
  payload: Fetch;
}

const uri = "/pedido/v1/cadastrarInclusao";
const uriAuthorization = "/pedido/v1/pagamentoautorizacao";
const uriPayment = "/pedido/v1/pagamentoInclusao";

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* createVehicle({
  payload,
}: CreateVehicleAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomer);
    const client = customer?.client;

    const vehicle = payload.vehicle;

    const address =
      client?.addresses?.find((address) => address?.main) ??
      client?.addresses?.[0];

    const body = {
      identificadorStatus: 10,
      nome: client?.name,
      cpfCnpj: client?.document,
      numeroCelular: client?.phone,
      email: client?.email,
      dataNascimento: client?.birthday || moment().format("YYYY-MM-DD"),
      dadosPagamento: {
        idModalidadePagamento: "1",
        idFormaPagamento: "2",
      },
      endereco: {
        cep: address?.zipcode,
        logradouro: address?.streetName,
        numero: address?.number,
        complemento: address?.complement ?? "-",
        bairro: address?.neighborhood,
        cidade: address?.city,
        estado: address?.state?.name!,
      },
      veiculo: {
        fabricante: payload.vehicleInfos.brandName,
        modelo: payload.vehicleInfos.modelName,
        placa: clearString(vehicle.plate).toUpperCase(),
        tipoVeiculo: Number(vehicle.type),
        anoModelo: "2000",
        hashPlaca: vehicle.plateCode,
      },
    };

    const response: AxiosResponse = yield call(automaticApi.post, uri, body);
    const responseData = response?.data;

    if (responseData?.status?.codigoRetorno === 0) {
      const orderId = responseData?.dados?.dados?.pedido;

      const deviceFingerprintID = getFormattedDeviceFingerPrintID(
        payload.visitorId,
      );

      const responseAuthorization: AxiosResponse = yield call(
        automaticApi.post,
        uriAuthorization,
        {
          identificadorStatus: "30",
          pedido: orderId,
          deviceFingerprintID,
        },
      );

      const responsePaymentThirdStep: AxiosResponse = yield call(
        automaticApi.post,
        uriPayment,
        {
          identificadorStatus: "60",
          pedido: orderId,
        },
      );

      if (
        responseAuthorization?.data?.status?.codigoRetorno === 0 &&
        responsePaymentThirdStep?.data?.status?.codigoRetorno === 0
      ) {
        yield call(payload.callback, true);
      } else {
        yield call(payload.callback, false);
      }
    } else {
      yield call(payload.callback, false);
    }
  } catch (err) {
    yield call(payload.callback, false);
  }
}
